<template>
  <div class="home">
      <div class="logo"></div>
      <div class="next" @click="nextFun"></div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  methods:{
      nextFun(){
          this.$router.push('/index')
      }
  }
}
</script>
<style scoped>
.home{
    width: 100%;
    height: 100%;
    background: url('../assets/home-bg.png') no-repeat center;
    background-size: cover;
}
.logo{
    width: 1.57rem;
    height: 0.48rem;
    background: url('../assets/logo.png') no-repeat center;
    background-size: cover;
    position: absolute;
    left: 0.5rem;
    top: 0.3rem;
    
    
}
.next{
    width: 3.94rem;
    height: 1.33rem;
    background: url('../assets/home-btn.png') no-repeat center;
    background-size: cover;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom:5%;
    /* bottom: calc(50% - 6.6rem); */
    /* transform: translateX(-50%); */
}
</style>
